'use strict';

var debounce = require('lodash/debounce');
const getWindowSizes = require('../utils/getWindowSizes');
const { initializeSliders, initializeSlidersStaggered, initializeSlidersLazy } = require('./sliders');

const getWindowBrowser = () => {
    const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]'; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    const isEdgeChromium = isChrome && (navigator.userAgent.indexOf('Edg') !== -1);
    const isBlink = (isChrome || isOpera) && !!window.CSS;

    if (isOpera) {
        $('body').addClass('cc-opera');
    } else if (isFirefox) {
        $('body').addClass('cc-firefox');
    } else if (isSafari) {
        $('body').addClass('cc-safari');
    } else if (isIE) {
        $('body').addClass('cc-ie');
    } else if (isEdge) {
        $('body').addClass('cc-edge');
    } else if (isEdgeChromium) {
        $('body').addClass('cc-edgeChromium');
    } else if (isChrome) {
        $('body').addClass('cc-chrome');
    } else if (isBlink) {
        $('body').addClass('cc-blink');
    } else {
        $('body').addClass('cc-unknown-browser');
    }
};

const responsiveResize = () => {
    getWindowSizes();

    if ($('.js-slider').length > 0) {
        initializeSliders();
    }
};

$(() => {
    getWindowBrowser();

    const patchMobileOnlyAccordionButtons = () => {
        const isMobile = window.matchMedia('(max-width: 1023.98px)').matches;

        $('.js-accordion-button-mobile-only').each(function () {
            const $btn = $(this);

            if (isMobile) {
                $btn.attr('type', 'button');
                $btn.attr('aria-expanded', $btn.attr('aria-expanded') || 'false');
                $btn.attr('aria-controls', $btn.data('target')?.replace('#', '') || '');
                $btn.attr('role', 'button');
                $btn.prop('disabled', false);
            } else {
                $btn.removeAttr('type aria-expanded aria-controls role');
                $btn.prop('disabled', true);
            }
        });
    };

    getWindowSizes();
    if ($('.js-slider').length > 0) {
        initializeSlidersLazy();
    }
    patchMobileOnlyAccordionButtons();

    $(window).on('resize', debounce(() => {
        responsiveResize();
        patchMobileOnlyAccordionButtons();
    }, 100));
});
